import React from "react";
import "./MerchantDashboard.css";
import PayinChart from "./PayinChart";

function SecondSection({ payInStatistic}) {
  return (
    <div>
      <div className="second-section">
        <div className="settlement-wallet box-back">
          <div>
            <p className="wallet-head heading-new">Payin Breakup</p>
            <p className="sub-heading-new">
              {" "}
              ₹{" "}
              {payInStatistic
                ? payInStatistic?.payIn?.payinSettlementAmount
                  ? Intl.NumberFormat("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(payInStatistic?.payIn?.payinSettlementAmount)
                  : "0.00"
                : "0.00"}
            </p>
          </div>

          <div className="normal-section">
            <p className="normal-font">
              <span className="heading-new">Deposit Amount:</span>
              <span className="price ">
                {" "}
                ₹{" "}
                {payInStatistic
                  ? payInStatistic?.payIn?.payinAmount
                    ? Intl.NumberFormat("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(payInStatistic?.payIn?.payinAmount)
                    : "0.00"
                  : "0.00"}
              </span>
            </p>
          </div>
          <div className="normal-section">
            <p className="normal-font">
              <span className="heading-new">Commission :</span>

              <span className="price ">
                {" "}
                - ₹{" "}
                {payInStatistic
                  ? payInStatistic?.payIn?.payinTotalComission
                    ? Intl.NumberFormat("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(payInStatistic?.payIn?.payinTotalComission)
                    : "0.00"
                  : "0.00"}
              </span>
            </p>
          </div>
          <div className="normal-section">
            <p className="normal-font">
              <span className="heading-new">Rolling Reserve :</span>

              <span className="price">
                {" "}
                - ₹{" "}
                {payInStatistic
                  ? payInStatistic?.payIn?.payinRollingReserve
                    ? Intl.NumberFormat("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(payInStatistic?.payIn?.payinRollingReserve)
                    : "0.00"
                  : "0.00"}
              </span>
            </p>
          </div>
          <div className="normal-section  line-data">
            <p className="normal-font">
              <span className="">Net Payin :</span>
              <span className="price">
                {" "}
                ₹{" "}
                {payInStatistic
                  ? payInStatistic?.payIn?.payinSettlementAmount
                    ? Intl.NumberFormat("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(payInStatistic?.payIn?.payinSettlementAmount)
                    : "0.00"
                  : "0.00"}
              </span>
            </p>
          </div>
        </div>

        <div className="chart-div settlement-wallet box-back">
          <PayinChart payInStatistic={payInStatistic} />
        </div>
      </div>
    </div>
  );
}

export default SecondSection;
